import React, { useState, useEffect } from 'react'
import queryString from "qs"
import { Button, Spin } from "antd"
import { Link } from "react-router-dom"
import DataTableHead from "./data/DataTableHead"
import DataTableBody from "./data/DataTableBody"
import DetailSearch from "./data/DetailSearch"
import { getInformationBatchBySku, exportBatchDetailBySku } from "../../../services/api/3dApi"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'

function StaticBatchesPage(props) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [statics, setStatics] = useState([])
    const [stateFilter, setFilters] = useState({})
    const [total, setTotal] = useState(0)

    const _fetchStatics = async () => {
        setLoading(true)
        setError('')

        try {
            const { history } = props
            const { location } = history
            let filters = {}
            let convertFilters = {}

            if (location.search !== '') {
                let sewing_time = ''
                const { search } = location
                const newString = search.slice(1)

                filters = queryString.parse(newString)

                if (filters.hasOwnProperty('sewing_time_type')) {
                    switch (filters.sewing_time_type) {
                        case 'received_1d':
                            sewing_time = { from: 0, to: 24 }
                            break
                        case 'received_2d':
                            sewing_time = { from: 24, to: 48 }
                            break
                        case 'received_3d':
                            sewing_time = { from: 48, to: 72 }
                            break
                        case 'received_4d':
                            sewing_time = { from: 72 }
                            break
                        case 'not_received':
                            sewing_time = 'not_received'
                            break
                        default:
                            sewing_time = ''
                    }
                }

                convertFilters = Object.assign(filters, { sewing_time: sewing_time })

                setFilters(convertFilters)
            }

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                convertFilters = Object.assign({ ...convertFilters }, { name: { '$in': filters.name } })
            }

            const newFilters = Object.assign(convertFilters, { page: 1, limit: 5000 })

            const { data: response } = await getInformationBatchBySku(newFilters)

            const { success, data, message } = response

            if (!success) {
                setLoading(false)

                return setError(message)
            }

            const { batches, results } = data
            let newData = []

            Object.keys(results).map(item => {
                return newData.push({ sku: item, ...results[item] })
            })

            setLoading(false)
            setTotal(batches)
            setStatics(newData)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _exportBatches = async () => {
        try {
            setError('')

            const { name = '', ...restStateFilter } = stateFilter
            const payload = { ...restStateFilter }
            if (!!name && !!Object.keys(name).length) {
                payload.name = { "$in": name }
            }
            const { data: res } = await exportBatchDetailBySku(payload)
            if (res) downloadFileFromData(res, { filename: `Batches-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })

        } catch (e) {
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchStatics()
        // eslint-disable-next-line
    }, [])

    return (
        <div className='StaticBatchesPage'>
            <Spin spinning={loading} tip='Đang lấy thông tin...'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="d-flex align-items-center justify-content-between">
                            <h3>Chi tiết danh sách kết quả lọc theo SKU (Tổng số lô lọc: {total || 0})</h3>

                            <div className="d-flex align-items-center">
                                <Link className='ant-btn mr-3 ant-btn-default' to='/batches'>
                                    Quay về danh sách lô
                                </Link>
                                <Button type='primary' onClick={_exportBatches}>Xuất CSV</Button>
                            </div>
                        </div>

                        <DetailSearch filters={stateFilter} />

                        <table className='table table-bordered'>
                            <DataTableHead />
                            <DataTableBody error={error} statics={statics} />
                        </table>
                    </div>
                </div>
            </Spin>
        </div>
    )
}

export default StaticBatchesPage
